import $ from 'jquery';
import checkKey from '../../scripts/util/event/checkKey';
import {login, registration, canRegister, recovery, subscribe} from '../api/api';
import isViewport from '../../scripts/util/window/isViewport';
import detectIE from '../../scripts/util/detect/detectIE';
import {tabletHor} from '../../scripts/util/window/isViewport';
import {enableScroll, disableScroll} from '../page/page';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-body',

			dom: {
				page: '.js-page-popup',
				popup: '.js-popup',
				close: '.js-close-popup',
				show: '.js-show-popup',
				container: '.js-popup-container',
				form: '.js-popup-form',
				success: '.js-popup-success',
				message: '.js-popup-message'
			},
			classes: {
				el: {
					state: {
						noscroll: 'noscroll'
					}
				},
				popup: {
					state: {
						visible: 'popup_state_visible',
						status: 'popup_status_visible'
					}
				},
				form: {
					hidden: 'popup__form_state_hidden'
				},
				success: {
					visible: 'popup__content_state_visible'
				},
				calendar: {
					cell: 'datepicker--cell',
					nav: 'datepicker--nav-action',
					title: 'datepicker--nav-title'
				},
				field: {
					state: {
						error: 'field__input_state_error'
					}
				}
			},
			message: {
				email: 'Такой email уже существует'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$popup = this.$el.find(this.options.dom.popup);
		this.$close = this.$el.find(this.options.dom.close);
		this.$show = this.$el.find(this.options.dom.show);
		this.$form = this.$el.find(this.options.dom.form);
		this.$container = this.$el.find(this.options.dom.container);
		this.$document = $(document);
		this.$window = $(window);
	}

	showPopup(e) {
		const $target = $(e.currentTarget);
		const type = $target.data('popup');
		const adaptive = $target.data('adaptive');
		const $targetPopup = this.$popup.filter('[data-type="' + type + '"]' );
		const isPage = $target.closest(this.options.dom.page).length;
		this.closePopup(this.$popup);
		if (!isViewport(tabletHor) && !isPage || adaptive) {
			e.preventDefault();
			$targetPopup.addClass(this.options.classes.popup.state.visible);
			disableScroll();
		}
	}

	showStatus(data, form, error = false, hideHead = false) {
		const dom = this.options.dom;
		const classes = this.options.classes;
		const $success = form.next(dom.success);
		const $message = $success.find(dom.message);
		const $back = $success.find(dom.close);
		const $popup = form.closest(this.options.dom.popup);
		const text = data.hasOwnProperty('message') ? data.message : 'Не удалось выполнить запрос';
		form.removeAttr('data-error');
		form.addClass(classes.form.hidden);
		$success.addClass(classes.success.visible);
		if (hideHead) {
			$popup.addClass(classes.popup.state.status);
		}
		if (text) {
			$message.html(text);
		}
		$back.on('click', this.closeOnClick);
		if (error) {
			$back.unbind('click');
			$back.on('click', this.back);
		}
	}

	showError = (data, $form) => {
		const text = data.hasOwnProperty('message') ? data.message : 'Не удалось выполнить запрос';
		$form.attr('data-error', text);
	}

	setFieldError = ($field, message) => {
		const $error = $field.next();
		$field.addClass(this.options.classes.field.state.error);
		$error.text(message);
	};

	back = e => {
		const $target = $(e.target);
		const $success = $target.closest(this.options.dom.success);
		const $form = $success.prev(this.$form);
		const $popup = $target.closest(this.options.dom.popup);

		$form.removeClass(this.options.classes.form.hidden);
		$success.removeClass(this.options.classes.success.visible);
		$popup.removeClass(this.options.classes.popup.state.status);
	}

	onSubmit(e) {
		e.preventDefault();
		const $target = $(e.target);
		const $mailField = $target.find('input[type="email"]');
		const type = $target.closest(this.options.dom.popup).data('type');
		const $data = $target.serialize();
		switch (type) {
			case 'login':
				login($data).then(
					() => location.reload(),
					data => this.showError(data, $target)
				);
				break;
			case 'reg':
				canRegister($mailField.val()).then(
					() => {
						registration($data).then(
							data => this.showStatus(data, $target),
							data => this.showError(data, $target)
						);
					},
					() => this.setFieldError($mailField, this.options.message.email)
				);

				break;
			case 'restore':
				recovery($data).then(
					data => this.showStatus(data, $target),
					data => this.showError(data, $target)
				);
				break;
			case 'subscribe-new':
				subscribe($data).then(
					data => this.showStatus(data, $target, false, true),
					data => this.showError(data, $target)
				);
				break;
		}
	}

	closePopup(popup) {
		if (popup && popup.hasClass(this.options.classes.popup.state.visible)) {
			popup.removeClass(this.options.classes.popup.state.visible);
			enableScroll();
		}
	}

	closeOnClick = e => {
		const $target = $(e.target);
		const $popup = $target.closest(this.$popup);
		this.closePopup($popup);
	}

	closeOnEsc(e) {
		const visibleClass = this.options.classes.popup.state.visible;
		const $popup = $('.' + visibleClass);

		if (checkKey(e)) {
			this.closePopup($popup);
		}
	}

	closeClickOutside(e) {
		const $target = $(e.target);
		const visibleClass = this.options.classes.popup.state.visible;
		const $popup = $(`.${visibleClass}`);

		const $container = $popup.find(this.$container);
		const isContainer = $target.closest($container).length;
		const isOpenBtn = $target.closest(this.$show).length;

		const isCell = $target.hasClass(this.options.classes.calendar.cell);
		const isArrow = $target.closest(`.${this.options.classes.calendar.nav}`).length;
		const isTitle = $target.closest(`.${this.options.classes.calendar.title}`).length;
		const isCalendar = !isCell && !isArrow && !isTitle;
		let closeCond = !isContainer && !isOpenBtn && isCalendar;

		if (detectIE()) {
			closeCond = !isContainer && !isOpenBtn && isCalendar && (e.target.tagName !== 'svg' && e.target.tagName !== 'path');
		}

		if (closeCond) {
			this.closePopup($popup);
		}
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$document.on('click', e => this.closeClickOutside(e));
			this.$show.on('click', e => this.showPopup(e));
			this.$close.on('click', this.closeOnClick);
			this.$document.on('keydown', e => this.closeOnEsc(e));
			this.$form.on('submit', e => this.onSubmit(e));
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/popup/popup.js
 **/